import axios from "axios";
import { attachAuthInterceptors } from "./attachAuthInterceptors";

const apiOrganizationClient = axios.create({
    baseURL:process.env.REACT_APP_API_ORGANIZATION,
    timeout: 30000
    // withCredentials: true
})

attachAuthInterceptors(apiOrganizationClient);

export default apiOrganizationClient